"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiPost = exports.api = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const app_1 = require("app");
const axios_1 = require("axios");
const api = (apiUrl, params, headers, cancelToken, timeout) => {
    const requestParams = {
        method: 'get',
        responseType: 'json',
        url: apiUrl + app_1.UrlService.GetStringFromUrlObj(params),
    };
    if (headers) {
        requestParams.headers = headers;
    }
    if (cancelToken) {
        requestParams.cancelToken = cancelToken;
    }
    if (timeout) {
        requestParams.timeout = timeout;
    }
    return (0, axios_1.default)(requestParams);
};
exports.api = api;
const apiPost = (apiUrl, params, headers, cancelToken, timeout) => {
    const requestParams = {
        data: params,
        method: 'post',
        url: apiUrl,
    };
    if (headers) {
        requestParams.headers = headers;
    }
    if (cancelToken) {
        requestParams.cancelToken = cancelToken;
    }
    if (timeout) {
        requestParams.timeout = timeout;
    }
    return (0, axios_1.default)(requestParams);
};
exports.apiPost = apiPost;
